import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import {
    Box, TablePagination, Paper, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, Button, Chip, Dialog, DialogTitle,
    Alert, DialogActions, DialogContent, Snackbar, TextField, Typography, Grid, Autocomplete
} from '@mui/material';
import moment from 'moment'
import MainCard from 'components/MainCard'
// import LinearProgress from '@mui/material/LinearProgress'
import Draggable from 'react-draggable'
// import { n_format } from '../../n_format';
import BarcodeScannerComponent from "react-qr-barcode-scanner";
import { orderBy } from 'lodash';

function PaperComponent(props) {
    return (
        <Draggable
            handle="#dialog1-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} />
        </Draggable>
    );
}

const Stock = () => {

    const [data, set_data] = useState([])
    const [rows_count, set_rows_count] = useState(1)
    const [settings, set_settings] = useState({
        order_by: 'id',
        order_desc: 'desc',
        per_page: 1000,
        page: 1
    })
    // const [max_updated_at, set_max_updated_at] = useState(0)

    // const [progress_num, set_progress_num] = useState(0)
    // const [progress_seconde, set_progress_seconde] = useState(60 * 1)
    const [dialog_edit_is_open, set_dialog_edit_is_open] = useState(false)
    const [dialog_edit_is_open1, set_dialog_edit_is_open1] = useState(false)
    const [dialog_item, set_dialog_item] = useState({})
    const [snackbar, set_snackbar] = useState(false)
    const [categoryOptions, setCategoryOptions] = useState([]);
    const [code_barre, set_code_barre] = useState('');
    const [barcode, setBarcode] = useState('');
    const [lastScanTime, setLastScanTime] = useState(Date.now());
    const [products, set_products] = useState([]);
    const [product, set_product] = useState([]);
    const [qte, set_qte] = useState('');
    const [progress, set_progress] = useState(false)
    // const inputRef = useRef();
    // const [Stock, setStock] = useState([]);

    const [permissions, set_permissions] = useState([]);
    useEffect(() => {
        axios
            .post(`${process.env.REACT_APP_API_URL}permissions?route=datamanaging/stocks`)
            .then((res) => set_permissions(res?.data))
            .catch(() => console.log('error!'))
    }, [])

    const fetchData = async () => {
        try {
            await load_data();
        } catch (error) {
            console.log('Error fetching data:', error);
            set_snackbar({ message: 'Error fetching data.', type: 'error' });
        }
    };

    // useEffect(() => {
    //     const interval = setInterval(() => {
    //         set_progress_num((moment().format('s') % progress_seconde + 1) / progress_seconde * 100)
    //         if (moment().format('s') % progress_seconde == 0) {
    //             sync_data()
    //         };
    //     }, 500)
    //     return () => clearInterval(interval)
    // }, [progress_seconde])

    useEffect(() => {
        fetchData()
        fetchCategories()
        load_products()
    }, [])

    useEffect(() => {
        fetchData();
    }, [settings]);

    useEffect(() => {
        if (dialog_edit_is_open) askPermission()
    }, [dialog_edit_is_open])

    useEffect(() => {
        const handleKeyPress = (e) => {
            if (e.key === 'Shift') {
                return;
            }
            if (e.key == 'undefined') {
                return;
            }
            if (e.key == 'Undefined') {
                return;
            }

            const currentTime = Date.now();
            if (currentTime - lastScanTime > 200) setBarcode(e.key);
            else setBarcode((prev) => prev + e.key);
            setLastScanTime(currentTime);

            if (e.key === 'Tab' && barcode?.length > 5) {
                // console.log('Scanned barcode:', barcode);
                // alert(`Scanned barcode: ${barcode}`);
                // console.log(Object.values(products)?.map(p => p?.ref));
                // set_product(null)
                set_dialog_edit_is_open1(true)
                set_qte('')
                // inputRef?.current?.focus()
                // inputRef?.current?.select();
                // if (!inputRef?.current)
                //     setTimeout(() => {
                //         set_product(Object.values(products)?.find(p => p?.ref == barcode))
                //         inputRef?.current?.focus()
                //         inputRef?.current?.select();
                //     }, 2000);

                set_product(Object.values(products)?.find(p => p?.ref == barcode))
                // set_qte(Object.values(products)?.find(p => p?.ref == barcode)?.qte ?? '')
                if (!Object.values(products)?.find(p => p?.ref == barcode)) {
                    set_dialog_edit_is_open1(false)
                    set_snackbar({ message: `Produit ${barcode} introuvable !` })
                }
                setTimeout(() => {
                    set_product(Object.values(products)?.find(p => p?.ref == barcode))
                    // set_dialog_edit_is_open1(true)
                    // console.log(Object.values(products)?.find(p => p?.ref == barcode));
                    // set_qte(Object.values(products)?.cfind(p => p?.ref == barcode)?.qte ?? '')
                }, 2000);

                setBarcode('');
                e.preventDefault()
            }
        };

        window.addEventListener('keydown', handleKeyPress);
        return () => window.removeEventListener('keydown', handleKeyPress);
    }, [barcode]);

    const askPermission = async () => {
        try {
            const stream = await navigator?.mediaDevices?.getUserMedia({ video: true });
            // On arrête les tracks (on ne garde pas la caméra active)
            stream?.getTracks().forEach(track => track.stop());
            // setMessage("✅ Accès à la caméra autorisé !");
        } catch (err) {
            console.error("Erreur d'accès caméra :", err);
            // setMessage("❌ Accès à la caméra refusé.");
        }
    };

    const fetchCategories = async () => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}categories`, { per_page: 200 });
            const categories = response.data.data;
            setCategoryOptions(categories);
        } catch (error) {
            console.log('Error fetching categories:', error);
        }
    };

    const load_data = async () => {
        await axios
            .post(`${process.env.REACT_APP_API_URL}stocks`, settings)
            .then((res) => {
                try {
                    set_data(res?.data?.data)
                    set_rows_count(res?.data?.total)
                } catch (error) {
                    set_snackbar({ message: error?.message ?? 'Error ! stocks' })
                }
            })
            .catch((err) => set_snackbar({ message: 'Error ! Chargement de donnees' }))
    };

    // const sync_data = async () => {
    //     await axios
    //         .get(`${process.env.REACT_APP_API_URL}stocks/max_updated_at`)
    //         .then((res) => {
    //             try {
    //                 if (res?.data != max_updated_at) {
    //                     fetchData();
    //                 }
    //                 set_max_updated_at(res?.data)
    //             } catch (error) {
    //                 console.log(error)
    //             }
    //         })
    //         .catch(() => console.log('error!'))
    // }

    // const create = async (data) => {
    //     try {
    //         const response = await axios.post(
    //             `${process.env.REACT_APP_API_URL}stocks`,
    //             data
    //         );
    //         if (response?.data?.result) {
    //             load_data();
    //             set_dialog_edit_is_open(false);
    //             set_snackbar({ message: 'stocks successfully created!', type: 'success' });
    //         } else {
    //             set_snackbar({ message: response?.data?.message ?? 'Error! Create stocks' });
    //         }
    //     } catch (error) {
    //         console.log('Error creating stock:', error);
    //         set_snackbar({ message: 'Error creating stock.', type: 'error' });
    //     }
    // };

    // const edit = async (data = dialog_item) => {
    //     try {
    //         const response = await axios.put(
    //             `${process.env.REACT_APP_API_URL}stocks`,
    //             data
    //         );
    //         if (response.data?.result) {
    //             load_data();
    //             set_dialog_edit_is_open(false);
    //             set_snackbar({
    //                 message: 'Stock successfully updated!',
    //                 type: 'success'
    //             });
    //         } else {
    //             set_snackbar({
    //                 message: response.data?.message ?? 'Error updating stock',
    //                 type: 'error'
    //             });
    //         }
    //     } catch (error) {
    //         set_snackbar({ message: 'Error updating stock.', type: 'error' });
    //     }
    // };

    const load_products = async () => {
        set_products([]);
        await axios
            .post(`${process.env.REACT_APP_API_URL}products`, {
                per_page: 2000000,
                filters: [
                    // ['products.company_id', '=', JSON.parse(localStorage.getItem('company'))?.id],
                    // ['type', 'in', ['MP', 'SF']],
                ]
            })
            .then((res) => {
                set_products(res?.data?.data);
            })
            .catch(() => console.log('error!'));
    };

    const edit = async (api, data) => {
        set_progress(true)
        await axios
            .put(`${process.env.REACT_APP_API_URL + api}`, data)
            .then((res) => {
                try {
                    if (res?.data?.result) {
                        load_data()
                        load_products()
                        set_dialog_edit_is_open1(false)
                        set_snackbar({ message: 'Successfully updated', type: 'success' });
                    }
                } catch (error) {
                    set_progress(false)
                    return fasle
                }
            })
            .catch(() => {
                console.log('error!')
                set_progress(false)
                return fasle
            })
        set_progress(false)
        return true
    }

    const MainCardButtonAdd =
        <>
            <Button type="submit" variant="contained" color="primary" onClick={() => {
                set_dialog_edit_is_open(true)
                // set_dialog_item({
                //     status_key: '',
                //     operation_id: '',
                //     user_id: '',
                //     product_id: '',
                //     company_id: ''
                // }), set_dialog_edit_is_open(true)
            }}>Scaner</Button>
        </>

    return (
        <MainCard title="Stocks" secondary={MainCardButtonAdd}>

            <Snackbar open={snackbar ? true : false} autoHideDuration={snackbar?.hide_duration ?? 3000} onClose={() => { set_snackbar(false) }}>
                <Alert onClose={() => { set_snackbar(false) }} severity={snackbar?.type ?? 'error'} sx={{ width: '100%' }}>{snackbar?.message}</Alert>
            </Snackbar>

            <Box>
                <Typography sx={{ mb: 3 }}>
                    Filter  :
                </Typography>

                <Box display="flex" alignItems="center" justifyContent="space-between" marginBottom={10}>

                    <Grid container display="flex" alignItems="center" gap={2}>

                        <Grid item xs={12} sm={3}>
                            <Autocomplete
                                disablePortal
                                disableListWrap
                                size="small"
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                value={categoryOptions.find(v => v.id === (settings?.filters ?? []).find(f => f?.[0] === 'product.category_id')?.[2]) ?? null}
                                options={categoryOptions ?? []}
                                renderInput={(params) => <TextField {...params} label="Categorie" />}
                                getOptionLabel={(o1) => o1?.name}
                                onChange={(e, v) => {
                                    v ?
                                        set_settings({ ...settings, filters: [...(settings?.filters ?? []).filter(f => f?.[0] != 'product.category_id'), ['product.category_id', 'like', v?.id]] })
                                        :
                                        set_settings({ ...settings, filters: [...(settings?.filters ?? []).filter(f => f?.[0] != 'product.category_id')] })
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={2}>
                            <Autocomplete
                                disablePortal
                                disableListWrap
                                size="small"
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                value={['PA', 'MP', 'SF', 'PF', 'PV'].find(v => v === (settings?.filters ?? []).find(f => f?.[0] == 'product.type')?.[2]) ?? ''}
                                options={['PA', 'MP', 'SF', 'PF', 'PV']}
                                renderInput={(params) => <TextField {...params} label="Type" />}
                                onChange={(e, v) => {
                                    v ?
                                        set_settings({ ...settings, filters: [...(settings?.filters ?? []).filter(f => f?.[0] != 'product.type'), ['product.type', 'like', v]] })
                                        :
                                        set_settings({ ...settings, filters: [...(settings?.filters ?? []).filter(f => f?.[0] != 'product.type')] })
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <TextField
                                label="Name"
                                size="small"
                                fullWidth
                                value={((settings?.filters ?? []).find(f => f?.[0] === 'product.name')?.[2] ?? '').replace(/%/g, '')}
                                onChange={e => {
                                    e.target.value ?
                                        set_settings({ ...settings, filters: [...(settings?.filters ?? []).filter(f => f?.[0] != 'product.name'), ['product.name', 'like', '%' + e.target.value + '%']] })
                                        :
                                        set_settings({ ...settings, filters: [...(settings?.filters ?? []).filter(f => f?.[0] != 'product.name')] })
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={4}>
                            <TextField
                                label="Ref"
                                size="small"
                                fullWidth
                                value={((settings?.filters ?? []).find(f => f?.[0] === 'product.ref')?.[2] ?? '').replace(/%/g, '')}
                                onChange={e => {
                                    e.target.value ?
                                        set_settings({ ...settings, filters: [...(settings?.filters ?? []).filter(f => f?.[0] != 'product.ref'), ['product.ref', 'like', '%' + e.target.value + '%']] })
                                        :
                                        set_settings({ ...settings, filters: [...(settings?.filters ?? []).filter(f => f?.[0] != 'product.ref')] })
                                }}
                            />
                        </Grid>

                    </Grid>

                </Box>
            </Box>

            {/* <LinearProgress variant="determinate" value={progress_num} sx={{ mb: 2 }} /> */}

            <Box>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 15, 25, 50, 100, 500, 1000]}
                    component="div"
                    labelRowsPerPage="Ligne/Page"
                    count={rows_count}
                    rowsPerPage={settings?.per_page}
                    page={settings?.page - 1}
                    onPageChange={(event, newPage) => set_settings({ ...settings, page: newPage + 1 })}
                    onRowsPerPageChange={(event) => set_settings({ ...settings, page: 1, per_page: event.target.value })}
                />

                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Categorie</TableCell>
                                <TableCell>Ref</TableCell>
                                <TableCell>Produit</TableCell>
                                <TableCell>Min Stock</TableCell>
                                <TableCell>Qte</TableCell>
                                <TableCell>Dernière Entré</TableCell>
                                <TableCell>Dernière Commande</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data?.length > 0 && data.map((row, i) => (
                                <TableRow key={row?.product_id} 
                                    sx={{ '& > *': { borderBottom: 'unset' }, backgroundColor: (row?.product?.min_stock && row?.qte <= row?.product?.min_stock) ? '#f77f5b' : '' }}
                                >
                                    <TableCell>{row?.product?.category?.name}</TableCell>
                                    <TableCell>{row?.product?.ref}</TableCell>
                                    <TableCell>{row?.product?.name}</TableCell>
                                    <TableCell>{row?.product?.min_stock}</TableCell>
                                    <TableCell>{row?.qte}</TableCell>
                                    <TableCell>{row?.last_purchase ? moment(row.last_purchase).format('DD/MM HH:mm') : ''}</TableCell>
                                    <TableCell>{row?.last_order ? moment(row.last_order).format('DD/MM//yyyy HH:mm') : ''}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>


                <TablePagination
                    rowsPerPageOptions={[5, 10, 15, 25, 50, 100, 500, 1000]}
                    component="div"
                    labelRowsPerPage="Ligne/Page"
                    count={rows_count}
                    rowsPerPage={settings?.per_page}
                    page={settings?.page - 1}
                    onPageChange={(event, newPage) => set_settings({ ...settings, page: newPage + 1 })}
                    onRowsPerPageChange={(event) => set_settings({ ...settings, page: 1, per_page: event.target.value })}
                />
            </Box>

            <Dialog open={dialog_edit_is_open1} fullScreen onClose={() => set_dialog_edit_is_open1(false)}>
                <DialogTitle id="dialog1-title">{product?.name}</DialogTitle>
                <DialogContent dividers>
                    <Grid container xs={12} sm={4}>
                        <TextField
                            fullWidth
                            InputProps={{
                                style: { fontSize: '16px' } // ✅ prevents zoom on mobile
                            }}
                            sx={{
                                '& input': {
                                    fontSize: '16px', // also good for custom themes
                                }
                            }}
                            size="small"
                            label="Quantité"
                            // inputProps={{ min: 0, max: 1000, step: 1 }}
                            type="number"
                            // inputRef={inputRef}
                            value={qte == '' ? product?.qte : qte}
                        />
                        <Grid item container spacing={1} sx={{ my: 2 }}>
                            {[1, 2, 3, 4, 5, 6, 7, 8, 9, '', 0].map((num, index) => (
                                <Grid item xs={4} key={index}>
                                    {num !== '' ? (
                                        <Button
                                            variant="outlined"
                                            fullWidth
                                            sx={{ py: 2, fontSize: '20px' }}
                                            onClick={() => set_qte((prev) => prev + num.toString())}
                                        >
                                            {num}
                                        </Button>
                                    ) : (
                                        <div style={{ height: '48px' }} />
                                    )}
                                </Grid>
                            ))}
                        </Grid>
                        <Grid item xs={6} sx={{ px: 1 }}>
                            <Button
                                variant="contained"
                                color="error"
                                fullWidth
                                onClick={() => set_qte('')}
                                sx={{ py: 1.5, fontSize: '16px', mt: 1 }}
                            >
                                Retour
                            </Button>
                        </Grid>
                        <Grid item xs={6} sx={{ px: 1 }}>
                            <Button
                                variant="contained"
                                color="primary"
                                fullWidth
                                onClick={() => edit('mouvements', { product_id: product?.id, qte: qte - product?.qte })}
                                sx={{ py: 1.5, fontSize: '16px', mt: 1 }}
                            >
                                Modifier
                            </Button>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => set_dialog_edit_is_open1(false)} color="secondary">Retour</Button>
                    {/* <Button onClick={() => { }} color="primary"> Modifier </Button> */}
                </DialogActions>
            </Dialog>

            <Dialog open={dialog_edit_is_open} onClose={() => set_dialog_edit_is_open(false)} fullWidth maxWidth="sm" PaperComponent={PaperComponent}>
                <DialogTitle id="dialog1-title">{dialog_item?.id ? 'Edit' : 'Add'} Operation</DialogTitle>
                <DialogContent dividers>
                    <BarcodeScannerComponent sx={{ border: 1 }}
                        // width={200}
                        // height={200}
                        onUpdate={(err, result) => {
                            if (err) {
                                console.warn("Caméra non détectée ou inactivité.");
                                return;
                            }
                            if (result) {
                                alert(result?.text)
                                set_code_barre(result.text);
                            }
                        }}
                    />
                    <p>Code détecté : {code_barre}</p>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => set_dialog_edit_is_open(false)} color="secondary">Cancel</Button>
                    <Button onClick={() => { }} color="primary"> Save </Button>
                </DialogActions>
            </Dialog>
        </MainCard>

    );
}

export default Stock;
